import { render, staticRenderFns } from "./SingleSiteIoTDashboard.vue?vue&type=template&id=2dd6b70a&scoped=true"
import script from "./SingleSiteIoTDashboard.vue?vue&type=script&lang=js"
export * from "./SingleSiteIoTDashboard.vue?vue&type=script&lang=js"
import style0 from "./SingleSiteIoTDashboard.vue?vue&type=style&index=0&id=2dd6b70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd6b70a",
  null
  
)

export default component.exports